module.exports = __webpack_public_path__ + "img/001.bbe64073.png";